import {ReactNode} from "react";
import {useTranslation} from "react-i18next";
import {DibJsonNode, RenderableDocument} from "../../types";
import {extractText} from "../../contentUtils";
import {usePanel} from "../../panel/PanelContext";
import contentLinkClasses from "../contentLink.module.css";
import {bffApi} from "../../../chat/bffApi";
import {metricUuid, newMetricEvent} from "../../../chat/metrics";

export const AutoLink = ({
    node,
    children,
    map,
    rootTopicId,
}: {
    node: DibJsonNode;
    children: ReactNode[];
    map: RenderableDocument;
    rootTopicId?: string;
}) => {
    const {openPanel} = usePanel();
    const {t} = useTranslation();
    const [trackInteraction] = bffApi.endpoints.trackInteraction.useMutation();

    if (!node.object || !(node.object.type === "linkdata")) {
        return <span>{children}</span>;
    }

    const queryParams = {
        resourceId: "",
        segmentId: "",
        id: "",
    };

    switch (node.object.data.type) {
        case "auto-link": {
            const qpResource = rootTopicId ?? "UNKNOWN";
            const qpSegment = "auto-link"; // Hard coded value by design.
            const qpId = node.object.id; // Object id for the link itself.
            queryParams.resourceId = qpResource;
            queryParams.segmentId = qpSegment;
            queryParams.id = qpId;
            break;
        }
        case "preview":
            queryParams.resourceId = node.object.data.topicId;
            queryParams.segmentId = node.object.data.segmentId ?? "";
            queryParams.id = node.object.data.id;
            break;
        default:
    }

    const title =
        extractText(map.elements, node.object.id) ||
        t("Word.Content", {defaultValue: "Content"});

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        void trackInteraction({
            ...newMetricEvent(),
            action: "content_link_opened",
            subjectId: metricUuid(queryParams.resourceId || map.topicId),
            linkKind: "dotted",
        });
        openPanel({
            label: title,
            fetchType: "documentParts",
            params: {
                resourceId: queryParams.resourceId,
                segmentId: queryParams.segmentId,
                id: queryParams.id,
            },
        });
    };

    return (
        <a href="#" data-pw="content-reference" className={contentLinkClasses.panelLink} onClick={handleClick}>
            {children}
        </a>
    );
};
